import { useSelector } from "react-redux";

import classes from "../../purchase.module.scss";
import { formatMilesDecimalNew } from "@/services/Utils";

const OrdersTableBodyDetail = ({ item }) => {
	const { customer } = useSelector((state) => state.auth.user);

	if (!item.active) {
		return null;
	}

	return (
		<tr className={classes.table_detail}>
			<td colSpan={customer.use_estates_parents ? 14 : 13} className={classes.td_table}>
				<table className={classes.table_item}>
					<thead>
						<tr className={classes.table_item_tr}>
							<th className={classes.th_detail} style={{ width: "15%" }}>
								Producto
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Contenido
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								U.M
							</th>
							<th className={classes.th_detail} style={{ width: "15%" }}>
								Cant. Recepcionado
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								% Recepcionado
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Precio
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Observaciones
							</th>
						</tr>
					</thead>
					<tbody>
						{item &&
							item.items.map((product, i) => {
								const quantity_reception = String(product.quantity_reception).replace(".", ",");

								return (
									<tr key={i} className={`${classes.table_item_tr}`}>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${classes.first_div}`}>{product.product_name}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{formatMilesDecimalNew(product.container_content)}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{product.unit_measurement}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{formatMilesDecimalNew(quantity_reception)}</div>
										</td>
										<td className={classes.table_item_td}>
											<div
												className={`${classes.div_item}`}
												style={{
													backgroundColor:
														Number(product.reception) < 100 ? "#ff030359" : Number(product.reception) >= 100 && "#05930059",
													color: Number(product.reception) < 100 ? "red" : Number(product.reception) >= 100 && "green",
												}}
											>
												{Number(product.reception) >= 100 ? 100 : formatMilesDecimalNew(String(product.reception).replace(".", ","))}%
											</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{formatMilesDecimalNew(product.price_total)}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${classes.last_div}`}>{product.type_product}</div>
										</td>
									</tr>
								);
							})}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

export default OrdersTableBodyDetail;
